// @flow
import React, { useEffect, useState } from 'react';
import ErrorBoundary from 'javascripts/utils/ErrorBoundary';
import useMediaquery from 'javascripts/hooks/useMediaquery';
import { MEDIA_QUERIES } from 'javascripts/constants';
import type { Config } from '../types';
import DiagramDisplay from './DiagramDisplay';
import Calculator from './Calculator';

const Fallback = () => <div>Something went wrong</div>;

const TaxCalculator = ({
  wording,
  data,
  variant,
}: Config): React$MixedElement => {
  const [display, setDisplay] = React.useState('diagram');
  const [accessibleMode, setAccessibleMode] = useState(false);
  const isTablet = useMediaquery(MEDIA_QUERIES.l);

  const handleDisplay = () => {
    setDisplay(display === 'diagram' ? 'list' : 'diagram');
  };

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    const prefersHighContrast = window.matchMedia(
      '(prefers-contrast: more)'
    ).matches;

    if (prefersReducedMotion || prefersHighContrast) {
      setAccessibleMode(true);
    }

    // Detect keyboard navigation
    const handleKeyDown = (event: any) => {
      if (event.key === 'Tab') {
        setAccessibleMode(true);
        window.removeEventListener('keydown', handleKeyDown);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    // eslint-disable-next-line consistent-return
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (accessibleMode) {
      setDisplay('list');
    } else if (isTablet) {
      setDisplay('diagram');
    } else {
      setDisplay('list');
    }
  }, [isTablet, accessibleMode]);

  return (
    <ErrorBoundary fallbackComponent={Fallback}>
      {variant === 'calculator' && (
        <Calculator
          data={data}
          wording={wording}
          display={display}
          setDisplay={handleDisplay}
        />
      )}
      {variant === 'default' && (
        <DiagramDisplay
          data={data}
          display={display}
          setDisplay={handleDisplay}
          wording={wording}
        />
      )}
    </ErrorBoundary>
  );
};

export default TaxCalculator;
